import classnames from 'classnames';
import React from 'react';
import { BaseOperateView, getFramework, useIdentity, useScale } from '@/framework';
import { type ILayerProps } from '@/version-types';
import type { SmartGuideBlock, SmartGuideLine } from '../types';
import './helper-view.less';

type Props = {
    /** 吸附线 */
    lines: readonly SmartGuideLine[];
    /** 等间距线 */
    blocks: readonly SmartGuideBlock[];
};
const HelperView: React.FC<Props> = ({ lines, blocks }) => {
    const identity = useIdentity();
    const framework = getFramework(identity);
    const scale = useScale();

    const referredLayerMap = [...lines, ...blocks].reduce((layerMap, item) => {
        if (item.id) {
            const layer = framework.service.flatLayer.getLayer(item.id);
            if (layer) {
                layerMap.set(item.id, layer);
            }
        }
        return layerMap;
    }, new Map<string, ILayerProps>());

    return (
        <BaseOperateView layer={framework.service.frame.getShape(framework.service.frame.getActiveFrameId())}>
            {/* 高亮被对齐的图层 */}
            {Array.from(referredLayerMap.values()).map((referredLayer) => {
                return (
                    <div
                        className="l-smart-referred-layer"
                        key={referredLayer.id}
                        style={{
                            left: referredLayer.left * scale - 0.5,
                            top: referredLayer.top * scale - 0.5,
                            width: referredLayer.width * scale + 1,
                            height: referredLayer.height * scale + 1,
                            transform: referredLayer.rotate ? `rotate(${referredLayer.rotate}deg)` : '',
                        }}
                    ></div>
                );
            })}

            {/* 吸附线 */}
            {lines.map((item, idx1) => {
                const { points, isHorizontal } = item;
                const [startPoint] = points;
                const [endPoint] = points.slice(-1);
                const offsetTop = 0;
                // const layer = framework.service.flatLayer.getLayer(item.id);
                // if (layer) {
                //     offsetTop = framework.service.transform.calcLayerOffsetTop(layer);
                // }
                return (
                    <React.Fragment key={idx1}>
                        <div
                            className={classnames('l-smart-guide-line', {
                                'l-smart-guide-line__horizontal': isHorizontal,
                                'l-smart-guide-line__vertical': !isHorizontal,
                            })}
                            style={{
                                left: startPoint.x * scale,
                                top: (startPoint.y + offsetTop) * scale,
                                width: isHorizontal ? (endPoint.x - startPoint.x) * scale : 1,
                                height: isHorizontal ? 1 : (endPoint.y - startPoint.y) * scale,
                            }}
                        ></div>

                        {points.map((point, idx2) => {
                            return (
                                <div
                                    key={idx1 + '-' + idx2}
                                    className="l-smart-guide-line__point"
                                    style={{
                                        left: point.x * scale,
                                        top: (point.y + offsetTop) * scale,
                                    }}
                                ></div>
                            );
                        })}
                    </React.Fragment>
                );
            })}

            {/* 等间距线 */}
            {blocks.map((item, idx3) => {
                const offsetTop = 0;
                // const layer = framework.service.flatLayer.getLayer(item.id);
                // if (layer) {
                //     offsetTop = framework.service.transform.calcLayerOffsetTop(layer);
                // }
                // const obj = framework.service.edgelessCanvas.getByLayerId(item.id);
                // // if (!obj) {
                // //     console.log('等间距线对应的图层不存在', item, item.id);
                // // }
                // const transform = obj?.getOriginCenterTransform();
                // console.log('item', item.id);
                const blockStyle = {
                    left: item.left * scale,
                    top: (item.top + offsetTop) * scale,
                    width: item.width * scale,
                    height: item.height * scale,
                };

                return (
                    <div
                        key={idx3}
                        className={classnames('l-smart-interval', {
                            'l-smart-interval__horizontal': item.isHorizontal,
                            'l-smart-interval__vertical': !item.isHorizontal,
                        })}
                        style={blockStyle}
                    >
                        <div className="l-smart-interval__gap-line"></div>
                        <div className="l-smart-interval__point l-smart-interval__point1"></div>
                        <div className="l-smart-interval__point l-smart-interval__point2"></div>
                    </div>
                );
            })}
        </BaseOperateView>
    );
};

export default React.memo(HelperView);
